import { pluralize } from "@sellar-io/common";
import { Icon } from "../../../components";
import { AlertCompact } from "../../../components/alert/AlertCompact";
import { useSupplierRelationshipPaymentTermsRequestCount } from "../../../hooks/api/v2/supplierRelationshipPaymentTermsRequest/useSupplierRelationshipPaymentTermsRequestCount";

export const CustomerPaymentTermsRequestBanners = () => {
  const connectionPaymentTermsRequestCountQuery =
    useSupplierRelationshipPaymentTermsRequestCount();

  const paymentTermsRequestCount =
    connectionPaymentTermsRequestCountQuery.data ?? 0;

  if (paymentTermsRequestCount === 0) return null;

  return (
    <AlertCompact
      type="request"
      // onClick={() =>
      //   setFilterValue(CustomerPaymentFilterValues.requestedPaymentTerms.key)
      // }
      className="w-full md:w-auto"
    >
      <span className="font-bold text-lime-700">
        {paymentTermsRequestCount} new credit terms{" "}
        {pluralize("request", paymentTermsRequestCount)}{" "}
        <span className="font-normal">pending</span>
      </span>
      <span className="ml-auto flex items-center font-bold text-lime-700 md:ml-2">
        View <Icon icon="CHEVRON_RIGHT" />
      </span>
    </AlertCompact>
  );
};
